import { RouteObject } from 'react-router';

import { ROUTES } from '~shared/routes';

export const deliveryRoutes: RouteObject = {
  children: [
    {
      path: ROUTES.delivery.locker,
      lazy: async () => {
        const { CncConfigDeliveryCasierPage } =
          await import('../../../pages/delivery/CncConfigDeliveryCasier.page');

        return { Component: CncConfigDeliveryCasierPage };
      },
    },
    {
      path: ROUTES.delivery.uber,
      lazy: async () => {
        const { DeliveryUberPage } =
          await import('../../../pages/cnc-configuration');

        return { Component: DeliveryUberPage };
      },
    },
    {
      path: ROUTES.delivery.deliveryService,
      lazy: async () => {
        const { CncConfigDeliveryLivraisonPage } =
          await import('../../../pages/delivery/CncConfigDeliveryLivraison.page');

        return { Component: CncConfigDeliveryLivraisonPage };
      },
    },
    {
      path: ROUTES.delivery.addressesManagement,
      lazy: async () => {
        const { CncConfigPickupPointPage } =
          await import('../../../pages/delivery/CncConfigPickupPoint.page');

        return { Component: CncConfigPickupPointPage };
      },
    },
  ],
};
